import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GeneralService } from 'src/app/services/general.service';

@Component({
  selector: 'app-service-list',
  templateUrl: './service-list.component.html',
  styleUrls: ['./service-list.component.scss']
})
export class ServiceListComponent implements OnInit {

  @Input() dsPagedService: any;

  constructor(private router: Router, public generalService: GeneralService) { }

  ngOnInit() {
  }

  openSWOEdit(swoid){
    this.router.navigateByUrl('/editSWO');
  }

}
